(() => {
  const key = 'cb-newsletter-teaser-motion-v2';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reducedMotion.matches || !Element.prototype.animate) return;
  try {
    if (sessionStorage.getItem(key)) return;
  } catch (_) {
    return;
  }

  const selector = ['UdELBj', 'VXn9Qr', 'WyQGmr', 'UvkxJ4', 'Sz5TCW', 'Ujn2Zs', 'VVkTJr', 'V7LYDc']
    .map(id => '.kl-teaser-' + id).join(',');
  let target;
  let timer;
  let frame;
  let animation;
  let stopped = false;

  const visible = element => {
    if (!element.isConnected || document.hidden) return false;
    const box = element.getBoundingClientRect();
    if (box.width <= 0 || box.height <= 0) return false;
    const x = box.left + box.width / 2;
    const y = box.top + box.height / 2;
    if (x < 0 || y < 0 || x >= innerWidth || y >= innerHeight) return false;
    const style = getComputedStyle(element);
    if (style.visibility !== 'visible' || Number(style.opacity) === 0) return false;
    return element.contains(document.elementFromPoint(x, y));
  };

  const stop = () => {
    stopped = true;
    clearTimeout(timer);
    clearTimeout(expiry);
    cancelAnimationFrame(frame);
    observer.disconnect();
    target?.removeEventListener('pointerdown', engaged);
    target?.removeEventListener('focusin', engaged);
    reducedMotion.removeEventListener('change', motionChanged);
    document.removeEventListener('visibilitychange', visibilityChanged);
    animation?.cancel();
  };
  const remember = () => {
    try {
      sessionStorage.setItem(key, '1');
      return true;
    } catch (_) {
      return false;
    }
  };
  const engaged = () => {
    remember();
    stop();
  };
  const motionChanged = () => {
    if (reducedMotion.matches) stop();
  };
  const visibilityChanged = () => {
    if (document.hidden) stop();
  };
  const scan = () => {
    frame = undefined;
    if (stopped || target) return;
    target = Array.from(document.querySelectorAll(selector)).find(visible);
    if (!target) return;
    observer.disconnect();
    target.addEventListener('pointerdown', engaged);
    target.addEventListener('focusin', engaged);
    timer = setTimeout(() => {
      if (reducedMotion.matches || !visible(target) || !remember()) return stop();
      target.dataset.cbTeaserMotion = 'played';
      animation = target.animate([
        { translate: '0px', rotate: '0deg' },
        { translate: '-7px', rotate: '-5deg' },
        { translate: '7px', rotate: '5deg' },
        { translate: '-5px', rotate: '-4deg' },
        { translate: '5px', rotate: '4deg' },
        { translate: '0px', rotate: '0deg' }
      ], { duration: 950, iterations: 1, easing: 'ease-in-out' });
      animation.finished.then(stop, stop);
    }, 2000);
  };
  const observer = new MutationObserver(() => {
    if (!frame && !stopped) frame = requestAnimationFrame(scan);
  });
  const expiry = setTimeout(stop, 120000);
  reducedMotion.addEventListener('change', motionChanged);
  document.addEventListener('visibilitychange', visibilityChanged);
  observer.observe(document.body, { childList: true, subtree: true });
  scan();
})();

